<template>
  <!-- prettier-ignore -->
  <div class="Bundle">
    <logo
      v-if="logo"
      class="logo"
    />

    <div class="packages">
      <template v-if="sortedPackages && sortedPackages.length > 0">
        <package-preview
          v-for="item in sortedPackages"
          :key="item.name"
          class="package"
          :item="item"
          :once="once"
          @clicked="$emit('requireDetail', item)"
        />
      </template>

      <ovp-loading-alt
        v-else
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { events$ } from '@/services'

import Logo from '@/modules/PartnerWidget/components/Logo'
import PackagePreview from '@/modules/PartnerWidget/components/package/PackagePreview'
import OvpLoadingAlt from '@/components/Container/LoadingAlt'

import { getRouteData } from '@/modules/PartnerWidget/helpers/tracking'
import { EVENT_PARTNER_WIDGET } from '@/config/events'
import { SortUtil } from '@/utils/Sorting'

// Init
const $emit = defineEmits(['requireDetail'])

// Props
const props = defineProps({
  logo: {
    type: Boolean,
    default: false,
  },

  packages: {
    type: Array,
    default: () => [],
  },

  skipEntryPage: {
    type: Boolean,
    default: false,
  },
})

// Computed
const once = computed(() => {
  return props.packages.length === 1
})

const sortedPackages = computed(() => {
  const packages = [...props.packages]
  return packages.sort(SortUtil.sortByOrder)
})

// Methods
function trackPartnerWidgetDisplayedAndPageViewed() {
  const trackingPayload = getRouteData({
    title: 'BundlesOverview',
    routes: ['bundles'],
  })
  events$.emit(EVENT_PARTNER_WIDGET.DISPLAYED, trackingPayload)
  events$.emit(EVENT_PARTNER_WIDGET.PAGE_VIEWED)
}

// Lifecycle hooks
onMounted(() => {
  if (!props.skipEntryPage) {
    trackPartnerWidgetDisplayedAndPageViewed()
  }
})
</script>

<style scoped>
.Bundle {
  .logo {
    margin-bottom: 15px;
  }

  /* type dependant stylings */

  .narrow & {
    .packages {
      .package {
        margin-bottom: 10px;
      }
    }
  }

  .wide &,
  .short & {
    .packages {
      display: flex;
      flex-shrink: 0;

      .package {
        margin-right: 20px;
        flex: 1;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        min-width: 250px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
}
</style>

<style name="short" scoped>
.Bundle {
  .short & {
    overflow-y: hidden;
    height: 100%;

    .logo {
      display: none;
    }

    .packages {
      height: 100%;
    }
  }
}
</style>
